// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── CMDB Login Page — Spectacular dark split-layout ──────── */

* { box-sizing: border-box; }

.login-page {
  display: flex;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
  background: var(--slate-50);
  overflow: hidden;
  position: relative;
}

/* ── Animated background ─────────────────────────────────── */
.l-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  background:
    radial-gradient(ellipse 80% 60% at 20% 10%, rgba(var(--accent-rgb),.18) 0%, transparent 60%),
    radial-gradient(ellipse 60% 50% at 80% 80%, rgba(139,92,246,.12) 0%, transparent 60%),
    radial-gradient(ellipse 50% 40% at 50% 50%, rgba(16,185,129,.06) 0%, transparent 70%),
    var(--slate-50);
}

.l-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  animation: orbDrift linear infinite;
}
.l-orb:nth-child(1) { width:600px; height:600px; top:-200px; left:-200px; background:rgba(var(--accent-rgb),.2); animation-duration:18s; }
.l-orb:nth-child(2) { width:500px; height:500px; bottom:-150px; right:-150px; background:rgba(139,92,246,.15); animation-duration:24s; animation-direction:reverse; }
.l-orb:nth-child(3) { width:300px; height:300px; top:40%; left:30%; background:rgba(16,185,129,.08); animation-duration:32s; }

@keyframes orbDrift {
  0%   { transform: translate(0, 0) scale(1); }
  25%  { transform: translate(30px, -20px) scale(1.05); }
  50%  { transform: translate(-20px, 30px) scale(0.95); }
  75%  { transform: translate(20px, 10px) scale(1.03); }
  100% { transform: translate(0, 0) scale(1); }
}

/* ── Grid overlay ──────────────────────────────────────────────
 * Retirada: el login se queda solo con los orbes difuminados, que es el mismo
 * lenguaje que el fondo de la aplicación (ver \`styles/background.css\`). */

/* ── Left branding panel ─────────────────────────────────── */
.l-brand {
  position: relative;
  z-index: 2;
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 4rem;
  gap: 2rem;
}

.l-brand-logo {
  display: flex;
  align-items: center;
  gap: 14px;
}

.l-brand-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--accent), var(--accent-2));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  box-shadow: 0 8px 24px rgba(var(--accent-rgb),.4);
}

.l-brand-name {
  font-size: 1.35rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -.3px;
}

.l-brand-name em {
  font-style: normal;
  color: var(--accent-l);
}

.l-headline {
  font-size: 2.8rem;
  font-weight: 700;
  line-height: 1.15;
  color: #fff;
  letter-spacing: -.5px;
}

.l-headline span {
  background: linear-gradient(135deg, var(--accent-l), #a5b4fc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.l-subtext {
  font-size: 1.05rem;
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 360px;
}

.l-pills {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.l-pill {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 14px;
  border-radius: 100px;
  background: var(--bg-input);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: .78rem;
  font-weight: 500;
}

.l-pill-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--accent);
  flex-shrink: 0;
}

/* ── Right card panel ────────────────────────────────────── */
.l-card-wrap {
  position: relative;
  z-index: 2;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.l-card {
  width: 100%;
  max-width: 440px;
  background: var(--bg-toolbar);
  backdrop-filter: blur(24px);
  border: 1px solid var(--slate-300);
  border-radius: 24px;
  padding: 2.5rem;
  box-shadow:
    0 32px 64px rgba(0,0,0,.5),
    0 0 0 1px rgba(var(--accent-rgb),.12),
    inset 0 1px 0 var(--bg-input);
}

.l-card-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 .4rem;
  letter-spacing: -.3px;
}

.l-card-sub {
  font-size: .9rem;
  color: var(--text-secondary);
  margin: 0 0 2rem;
}

/* ── SSO Button ──────────────────────────────────────────── */
.l-sso-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--accent), var(--accent-2));
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all .2s ease;
  box-shadow: 0 8px 24px rgba(var(--accent-rgb),.35);
  letter-spacing: .2px;
}

.l-sso-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(var(--accent-rgb),.5);
  background: linear-gradient(135deg, var(--accent-dark), #6d28d9);
}

.l-sso-icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: var(--slate-300);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .95rem;
}

/* ── Divider ─────────────────────────────────────────────── */
.l-divider {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 1.5rem 0;
  color: var(--text-muted);
  font-size: .8rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: .6px;
}

.l-divider::before,
.l-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--slate-300);
}

/* ── Demo button ─────────────────────────────────────────── */
.l-demo-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 12px;
  background: var(--bg-input);
  border: 1px solid var(--slate-300);
  border-radius: 12px;
  color: var(--text-secondary);
  font-size: .9rem;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: all .2s ease;
}

.l-demo-btn:hover {
  background: var(--bg-toolbar);
  border-color: var(--slate-300);
  color: var(--text-primary);
  transform: translateY(-1px);
}

/* ── Footer note ─────────────────────────────────────────── */
.l-footer {
  margin-top: 1.75rem;
  text-align: center;
  font-size: .78rem;
  color: var(--text-muted);
  line-height: 1.5;
}

/* Acceso a la página pública de descarga del agente (no requiere sesión). */
.l-agent-link {
  margin: 1.1rem 0 0;
  text-align: center;
  font-size: .8rem;
  color: var(--text-muted);
}

.l-agent-link a {
  color: var(--accent-l);
  text-decoration: none;
  font-weight: 600;
}

.l-agent-link a:hover {
  text-decoration: underline;
}

/* ── Error/info banner ───────────────────────────────────── */
.l-alert {
  margin-bottom: 1.25rem;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: .85rem;
  font-weight: 500;
}

.l-alert-error {
  background: rgba(239,68,68,.12);
  border: 1px solid rgba(239,68,68,.25);
  color: #fca5a5;
}

.l-alert-info {
  background: rgba(var(--accent-rgb),.12);
  border: 1px solid rgba(var(--accent-rgb),.25);
  color: #a5b4fc;
}

/* ── Responsive ──────────────────────────────────────────── */
@media (max-width: 860px) {
  .l-brand { display: none; }
  .l-card-wrap { width: 100%; }
}

@media (max-width: 480px) {
  .l-card { padding: 2rem 1.5rem; border-radius: 16px; }
  .l-headline { font-size: 2rem; }
}


.login-box .btn-secondary:hover {
  background-color: #5a6268;
  border-color: #5a6268;
}

.login-box .btn-info {
  background-color: #0dcaf0;
  border-color: #0dcaf0;
  color: #fff;
}

.login-box .btn-info:hover {
  background-color: #0bb5da;
  border-color: #0bb5da;
  transform: translateY(-1px);
  box-shadow: 0 5px 20px rgba(13, 202, 240, 0.4);
}

.divider-line {
  display: flex;
  align-items: center;
  text-align: center;
}

.divider-line::before,
.divider-line::after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid #dee2e6;
}

.divider-line > span {
  padding: 0 1rem;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
}

.login-footer {
  text-align: center;
  margin-top: 1.5rem;
  border-top: 1px solid #dee2e6;
  padding-top: 1.5rem;
}

.login-footer .text-muted {
  font-size: 0.875rem;
}

.text-sm {
  font-size: 0.75rem;
}

.w-100 {
  width: 100%;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mt-3 {
  margin-top: 1rem;
}

.mt-4 {
  margin-top: 1.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.alert {
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.alert-info {
  background-color: rgba(13, 202, 240, 0.1);
  color: #0c5460;
  border: 1px solid rgba(13, 202, 240, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE,IAAI,sBAAsB,EAAE;;AAE5B;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV;;;;mBAIiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;AACrC;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,WAAW,EAAE,qCAAqC,EAAE,sBAAsB,EAAE;AACzI,sBAAsB,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,YAAY,EAAE,+BAA+B,EAAE,sBAAsB,EAAE,2BAA2B,EAAE;AACpK,sBAAsB,WAAW,EAAE,YAAY,EAAE,OAAO,EAAE,QAAQ,EAAE,+BAA+B,EAAE,sBAAsB,EAAE;;AAE7H;EACE,OAAO,mCAAmC,EAAE;EAC5C,OAAO,6CAA6C,EAAE;EACtD,OAAO,6CAA6C,EAAE;EACtD,OAAO,4CAA4C,EAAE;EACrD,OAAO,mCAAmC,EAAE;AAC9C;;AAEA;;0EAE0E;;AAE1E,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mEAAmE;EACnE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf;;;iCAG+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mEAAmE;EACnE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,wBAAwB;EACxB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;EAClD,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,4BAA4B;AAC9B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,WAAW,aAAa,EAAE;EAC1B,eAAe,WAAW,EAAE;AAC9B;;AAEA;EACE,UAAU,oBAAoB,EAAE,mBAAmB,EAAE;EACrD,cAAc,eAAe,EAAE;AACjC;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,yCAAyC;AAC3C","sourcesContent":["/* ── CMDB Login Page — Spectacular dark split-layout ──────── */\r\n\r\n* { box-sizing: border-box; }\r\n\r\n.login-page {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  font-family: 'Inter', sans-serif;\r\n  background: var(--slate-50);\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n/* ── Animated background ─────────────────────────────────── */\r\n.l-bg {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 0;\r\n  background:\r\n    radial-gradient(ellipse 80% 60% at 20% 10%, rgba(var(--accent-rgb),.18) 0%, transparent 60%),\r\n    radial-gradient(ellipse 60% 50% at 80% 80%, rgba(139,92,246,.12) 0%, transparent 60%),\r\n    radial-gradient(ellipse 50% 40% at 50% 50%, rgba(16,185,129,.06) 0%, transparent 70%),\r\n    var(--slate-50);\r\n}\r\n\r\n.l-orb {\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  filter: blur(80px);\r\n  animation: orbDrift linear infinite;\r\n}\r\n.l-orb:nth-child(1) { width:600px; height:600px; top:-200px; left:-200px; background:rgba(var(--accent-rgb),.2); animation-duration:18s; }\r\n.l-orb:nth-child(2) { width:500px; height:500px; bottom:-150px; right:-150px; background:rgba(139,92,246,.15); animation-duration:24s; animation-direction:reverse; }\r\n.l-orb:nth-child(3) { width:300px; height:300px; top:40%; left:30%; background:rgba(16,185,129,.08); animation-duration:32s; }\r\n\r\n@keyframes orbDrift {\r\n  0%   { transform: translate(0, 0) scale(1); }\r\n  25%  { transform: translate(30px, -20px) scale(1.05); }\r\n  50%  { transform: translate(-20px, 30px) scale(0.95); }\r\n  75%  { transform: translate(20px, 10px) scale(1.03); }\r\n  100% { transform: translate(0, 0) scale(1); }\r\n}\r\n\r\n/* ── Grid overlay ──────────────────────────────────────────────\r\n * Retirada: el login se queda solo con los orbes difuminados, que es el mismo\r\n * lenguaje que el fondo de la aplicación (ver `styles/background.css`). */\r\n\r\n/* ── Left branding panel ─────────────────────────────────── */\r\n.l-brand {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 45%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  padding: 3rem 4rem;\r\n  gap: 2rem;\r\n}\r\n\r\n.l-brand-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n}\r\n\r\n.l-brand-icon {\r\n  width: 52px;\r\n  height: 52px;\r\n  border-radius: 14px;\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-2));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.6rem;\r\n  box-shadow: 0 8px 24px rgba(var(--accent-rgb),.4);\r\n}\r\n\r\n.l-brand-name {\r\n  font-size: 1.35rem;\r\n  font-weight: 800;\r\n  color: #fff;\r\n  letter-spacing: -.3px;\r\n}\r\n\r\n.l-brand-name em {\r\n  font-style: normal;\r\n  color: var(--accent-l);\r\n}\r\n\r\n.l-headline {\r\n  font-size: 2.8rem;\r\n  font-weight: 700;\r\n  line-height: 1.15;\r\n  color: #fff;\r\n  letter-spacing: -.5px;\r\n}\r\n\r\n.l-headline span {\r\n  background: linear-gradient(135deg, var(--accent-l), #a5b4fc);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.l-subtext {\r\n  font-size: 1.05rem;\r\n  color: var(--text-secondary);\r\n  line-height: 1.6;\r\n  max-width: 360px;\r\n}\r\n\r\n.l-pills {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.l-pill {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 7px 14px;\r\n  border-radius: 100px;\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--border);\r\n  color: var(--text-secondary);\r\n  font-size: .78rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.l-pill-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: var(--accent);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Right card panel ────────────────────────────────────── */\r\n.l-card-wrap {\r\n  position: relative;\r\n  z-index: 2;\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem;\r\n}\r\n\r\n.l-card {\r\n  width: 100%;\r\n  max-width: 440px;\r\n  background: var(--bg-toolbar);\r\n  backdrop-filter: blur(24px);\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: 24px;\r\n  padding: 2.5rem;\r\n  box-shadow:\r\n    0 32px 64px rgba(0,0,0,.5),\r\n    0 0 0 1px rgba(var(--accent-rgb),.12),\r\n    inset 0 1px 0 var(--bg-input);\r\n}\r\n\r\n.l-card-title {\r\n  font-size: 1.6rem;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  margin: 0 0 .4rem;\r\n  letter-spacing: -.3px;\r\n}\r\n\r\n.l-card-sub {\r\n  font-size: .9rem;\r\n  color: var(--text-secondary);\r\n  margin: 0 0 2rem;\r\n}\r\n\r\n/* ── SSO Button ──────────────────────────────────────────── */\r\n.l-sso-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  width: 100%;\r\n  padding: 14px;\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-2));\r\n  border: none;\r\n  border-radius: 12px;\r\n  color: #fff;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  font-family: 'Inter', sans-serif;\r\n  cursor: pointer;\r\n  transition: all .2s ease;\r\n  box-shadow: 0 8px 24px rgba(var(--accent-rgb),.35);\r\n  letter-spacing: .2px;\r\n}\r\n\r\n.l-sso-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 12px 32px rgba(var(--accent-rgb),.5);\r\n  background: linear-gradient(135deg, var(--accent-dark), #6d28d9);\r\n}\r\n\r\n.l-sso-icon {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 6px;\r\n  background: var(--slate-300);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: .95rem;\r\n}\r\n\r\n/* ── Divider ─────────────────────────────────────────────── */\r\n.l-divider {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  margin: 1.5rem 0;\r\n  color: var(--text-muted);\r\n  font-size: .8rem;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  letter-spacing: .6px;\r\n}\r\n\r\n.l-divider::before,\r\n.l-divider::after {\r\n  content: '';\r\n  flex: 1;\r\n  height: 1px;\r\n  background: var(--slate-300);\r\n}\r\n\r\n/* ── Demo button ─────────────────────────────────────────── */\r\n.l-demo-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 12px;\r\n  background: var(--bg-input);\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: 12px;\r\n  color: var(--text-secondary);\r\n  font-size: .9rem;\r\n  font-weight: 600;\r\n  font-family: 'Inter', sans-serif;\r\n  cursor: pointer;\r\n  transition: all .2s ease;\r\n}\r\n\r\n.l-demo-btn:hover {\r\n  background: var(--bg-toolbar);\r\n  border-color: var(--slate-300);\r\n  color: var(--text-primary);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* ── Footer note ─────────────────────────────────────────── */\r\n.l-footer {\r\n  margin-top: 1.75rem;\r\n  text-align: center;\r\n  font-size: .78rem;\r\n  color: var(--text-muted);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Acceso a la página pública de descarga del agente (no requiere sesión). */\r\n.l-agent-link {\r\n  margin: 1.1rem 0 0;\r\n  text-align: center;\r\n  font-size: .8rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.l-agent-link a {\r\n  color: var(--accent-l);\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.l-agent-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ── Error/info banner ───────────────────────────────────── */\r\n.l-alert {\r\n  margin-bottom: 1.25rem;\r\n  padding: 10px 14px;\r\n  border-radius: 10px;\r\n  font-size: .85rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.l-alert-error {\r\n  background: rgba(239,68,68,.12);\r\n  border: 1px solid rgba(239,68,68,.25);\r\n  color: #fca5a5;\r\n}\r\n\r\n.l-alert-info {\r\n  background: rgba(var(--accent-rgb),.12);\r\n  border: 1px solid rgba(var(--accent-rgb),.25);\r\n  color: #a5b4fc;\r\n}\r\n\r\n/* ── Responsive ──────────────────────────────────────────── */\r\n@media (max-width: 860px) {\r\n  .l-brand { display: none; }\r\n  .l-card-wrap { width: 100%; }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .l-card { padding: 2rem 1.5rem; border-radius: 16px; }\r\n  .l-headline { font-size: 2rem; }\r\n}\r\n\r\n\r\n.login-box .btn-secondary:hover {\r\n  background-color: #5a6268;\r\n  border-color: #5a6268;\r\n}\r\n\r\n.login-box .btn-info {\r\n  background-color: #0dcaf0;\r\n  border-color: #0dcaf0;\r\n  color: #fff;\r\n}\r\n\r\n.login-box .btn-info:hover {\r\n  background-color: #0bb5da;\r\n  border-color: #0bb5da;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 5px 20px rgba(13, 202, 240, 0.4);\r\n}\r\n\r\n.divider-line {\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.divider-line::before,\r\n.divider-line::after {\r\n  content: '';\r\n  flex: 1;\r\n  border-bottom: 1px solid #dee2e6;\r\n}\r\n\r\n.divider-line > span {\r\n  padding: 0 1rem;\r\n  color: #6c757d;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.login-footer {\r\n  text-align: center;\r\n  margin-top: 1.5rem;\r\n  border-top: 1px solid #dee2e6;\r\n  padding-top: 1.5rem;\r\n}\r\n\r\n.login-footer .text-muted {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.w-100 {\r\n  width: 100%;\r\n}\r\n\r\n.mb-2 {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.mt-3 {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.mt-4 {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.mb-4 {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.alert {\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 0.375rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.alert-info {\r\n  background-color: rgba(13, 202, 240, 0.1);\r\n  color: #0c5460;\r\n  border: 1px solid rgba(13, 202, 240, 0.3);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
